import {DIV_SLIDERS} from "../../../constants";
import {markerLayout} from "../layouts/markerLayout";

export const initDivSlider = (ymapsMap, ymapsObjectManager) => {
	const component = ymapsMap.container.getParentElement().closest(`section`);
	
	if (component)
	{
		const slider = document.querySelector(`div.slider-wrapper`);
		const slides = Array.from(slider.querySelectorAll(`ul.slider li[data-id]`));

		ymapsObjectManager.objects.events.add(`mouseenter`, (evt) => {
			const id = evt.get(`objectId`);
			const sliderIndex = slider.getAttribute(`data-i`);
			const nextSlide = slides.find(slide => slide.getAttribute(`data-id`) === id);
			const nextSlideIndex = slides.indexOf(nextSlide);
			DIV_SLIDERS[sliderIndex].goTo(nextSlideIndex);
			const objectId = evt.get(`objectId`);
			
			component.querySelector(`div.placemark.current`) ? component.querySelector(`div.placemark.current`).classList.remove(`current`) : false;
			ymapsObjectManager.objects.setObjectOptions(objectId, {
				iconLayout: markerLayout()
			});
		});

		slider.addEventListener(`click`, () => {
			const current = slider.querySelector(`ul li.tns-slide-active`).getAttribute(`data-id`);

			ymapsObjectManager.objects.events.fire(`mouseenter`, {objectId: current});
		});
	}
};
